import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';
import { memberByNumber } from '../../services/memberApiServices';
import defaultImg from "../../components/images/defaultPerson.png";
import gymLogo from '../../components/images/Easy-MembrLogo.png';
import { idToSlug } from '../../utils/slug';
import { getWaiverSettingsbyGymid } from '../../services/apiServices';





const Sidebar = ({ active, handleRefresh }) => {

  const { getGymId, getMemberId, getMemberNumber } = useCart();
  const [memberInfo, setMemberInfo] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  // console.log(memberInfo, 'memberInfo')
  const [waiverid, setWaiverid] = useState("")


  useEffect(() => {

    const gymid = localStorage.getItem("loggedMemberInfo") ? JSON.parse(localStorage.getItem("loggedMemberInfo")).gymid : -1
    const number = localStorage.getItem("loggedMemberInfo") ? JSON.parse(localStorage.getItem("loggedMemberInfo")).number : -1

    const fetchMembers = async () => {
      if (!localStorage.getItem("loggedMemberInfo")) {
        navigate('/memberlogin', { state: { path: '/memberdashboard' } })
        return
      }
      setIsLoading(true);
      if (gymid == -1) {
        return;
      }
      const membersinfo = await memberByNumber(gymid, { number: number }, "user");

      if (!membersinfo || membersinfo === "false") {
        return;
      }

      const members = await membersinfo.json();

      setMemberInfo(members);

      if (members.length > 0) {

        if (getMemberId() != -1) {

          const filteMember = members.find((item) => item._id == getMemberId())

          setSelectedMember(filteMember)
          setMemberdata(filteMember)
        } else {

          setSelectedMember(members[0]);

          setMemberdata(members[0]);
        }

        // setMemberId(members[0]._id);

      }

      setIsLoading(false);

    };



    if (number && gymid) {

      fetchMembers();

    }





  }, []);






  useEffect(() => {
    const fetchWaiverSettings = async () => {
      if (selectedMember?.bId) {
        const waiverRes = await getWaiverSettingsbyGymid(selectedMember.bId);
        if (waiverRes && waiverRes !== "false") {
          const waiver = await waiverRes.json();
          setWaiverid(waiver?.uniqueNumber || "");
        }
      }
    };

    if (selectedMember && selectedMember.iswaiververified === false) {
      fetchWaiverSettings();
    }
  }, [selectedMember]);


  useEffect(() => {

    const handleClickOutside = (event) => {

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {

        setIsDropdownOpen(false);

      }

    };



    document.addEventListener('mousedown', handleClickOutside);

    return () => {

      document.removeEventListener('mousedown', handleClickOutside);

    };

  }, []);



  const setMemberdata = (memberinfo) => {

    const update = {
      number: memberinfo?.number,
      username: memberinfo?.fname ? memberinfo.fname + " " + memberinfo.lname : null,
      fname: memberinfo?.fname ? memberinfo?.fname : null,
      lname: memberinfo?.lname ? memberinfo?.lname : null,
      imgurl: memberinfo?.imgurl ? memberinfo?.imgurl : null,
      gymid: memberinfo?.bId ? memberinfo?.bId : -1,
      id: memberinfo?._id ? memberinfo?._id : -1,
    }

    localStorage.setItem("memberinfo", JSON.stringify(update))

  }

  const handleMemberSelect = (member) => {
    setSelectedMember(member);
    // setMemberId(member._id);
    setMemberdata(member)
    setIsDropdownOpen(false);
    // window.location.reload();
    handleRefresh()

  };



  const toggleDropdown = () => {

    setIsDropdownOpen(!isDropdownOpen);

  };


    function encryptId(id) {
    return btoa(id);
  }


useEffect(() => {
  const processPendingRedirect = () => {
    const pendingRedirectUrl = sessionStorage.getItem("pendingRedirectUrl");
    console.log("pendingRedirectUrl:", pendingRedirectUrl);

    if (!pendingRedirectUrl) return;

 
    if (
      !localStorage.getItem("loggedMemberInfo") &&
      !localStorage.getItem("memberinfo")
    ) {
      navigate("/memberlogin", {
        state: { path: "/memberdashboard" },
      });
      return;
    }

// if (selectedMember?.iswaiververified === false) {
//     const pendingRedirectUrl = sessionStorage.getItem("pendingRedirectUrl");
    
//     if (pendingRedirectUrl) {
//         const slug = idToSlug(selectedMember._id);
//         const encryptedId = encryptId(waiverid);
//         const waiverUrl = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`;
        
//         navigate(waiverUrl);
//         return;
//     }
// }

    try {
      const url = new URL(pendingRedirectUrl);
      const finalPath = `${url.pathname}${url.search}`;

      // sessionStorage.removeItem("pendingRedirectUrl");
      navigate(finalPath);
        sessionStorage.removeItem("pendingRedirectUrl");

    } catch (err) {
      console.error("Invalid redirect URL:", pendingRedirectUrl);
    }
  };

  const timer = setTimeout(processPendingRedirect, 100);
  return () => clearTimeout(timer);
}, [navigate, selectedMember, waiverid]);







  const styles = `

  /* Custom dropdown styles */



.sidebar_member_selection {
  height: 75px;
  }

  .sidebar-member-dropdown-container {
    position: relative;
    margin: 0px 15px 15px 15px;
    z-index: 100;
  }



  /* Add this to your existing styles */
  .sidebar-selected-member {
    min-height: 36px;
    display: flex;
    align-items: center;
  }

  

  /* Loading state styles */

  .sidebar-member-dropdown-header [alt="Loading"] {
    opacity: 0.7;
  }

    

  .sidebar-member-dropdown-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }



  .sidebar-member-dropdown-header:hover {
    border-color: #4CAF50;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .sidebar-selected-member {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #333333;
    font-weight: 500;
  }


  .sidebar-member-image {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #f0f0f0;
  }

  .sidebar-member-dropdown-options {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    right: 0;
    max-height: 350px;
    overflow-y: auto;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    z-index: 1000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.2s ease-out;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .sidebar-dropdown-option {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #444444;
    border-bottom: 1px solid #f5f5f5;
  }

  .sidebar-dropdown-option:last-child {
    border-bottom: none;
  }

  .sidebar-dropdown-option:hover {
    background-color: #f8f8f8;
    color: #000000;
  }

  .sidebar-dropdown-option.selected {
    background-color: #f0f9ff;
    color: #0077cc;
    font-weight: 500;
  }

  /* Chevron icon */
  .fa-chevron-down,
  .fa-chevron-up {
    margin-left: 8px;
    font-size: 12px;
    color: #666666;
    transition: transform 0.2s ease;
  }

  /* Placeholder text */
  .sidebar-member-dropdown-header > span {
    color: #888888;
    font-style: italic;
  }

  /* Scrollbar styling */

  .sidebar-member-dropdown-options::-webkit-scrollbar {
    width: 6px;
  }

  .sidebar-member-dropdown-options::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0 8px 8px 0;

  }

  .sidebar-member-dropdown-options::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  .sidebar-member-dropdown-options::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .sidebar-member-name{
     color: #000000;
     font-weight: 500;

  }

`;



  // Add this component to your Sidebar component

  function DropdownStyles() {
    return <style>{styles}</style>;
  }



  const handleLogoutClick = () => {
    localStorage.removeItem("loggedMemberInfo");
    localStorage.removeItem("memberinfo");
    localStorage.removeItem("ipaddress");
    window.location.href = "/memberlogin";
  }

  return (
    <>
      <button className="sidebar-toggle-btn" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        <i className={`fas ${isSidebarOpen ? 'fa-times' : 'fa-bars'}`}></i>
      </button>
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="logo-header">
          <img
            src={gymLogo}
            className='membergym-logo'
            alt="Gym Logo" />
        </div>
        <div className='sidebar-menu'>
          {/* Custom Member Selection Dropdown */}
          <div className="sidebar_member_selection">
            {memberInfo.length > 0 && (
              <div className="sidebar-member-dropdown-container" ref={dropdownRef}>
                <div
                  className="sidebar-member-dropdown-header"
                  onClick={toggleDropdown}
                >
                  {selectedMember != null ? (
                    <div className="sidebar-selected-member">
                      <img
                        src={selectedMember?.imgurl || defaultImg}
                        alt="User"
                        className="sidebar-member-image"
                      />
                      <span>{selectedMember.fname} {selectedMember.lname}</span>
                    </div>
                  ) : (
                    <span>Select a member</span>
                  )}
                  <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}></i>
                </div>
                {isDropdownOpen && (
                  <div className="sidebar-member-dropdown-options">
                    {memberInfo.map((member) => (
                      <div
                        key={member._id}
                        className={`sidebar-dropdown-option ${selectedMember?._id === member._id ? 'selected' : ''}`}
                        onClick={() => handleMemberSelect(member)}
                      >
                        <img
                          src={member?.imgurl || defaultImg}
                          alt="User"
                          className="sidebar-member-image"
                        />
                        <span className="sidebar-member-name">{member.fname} {member.lname}</span>
                      </div>
                    ))}
                  </div>
                )}

              </div>
            )}
          </div>
          <div>
            <div>
              <ul className="sidebar-menu gym-bar-block mb-3">
                <label className='sidebar-title'>Activity</label>
                <li className={` ${active === "1" ? "active" : ""
                  }`}>
                  <Link
                    id="hs-bp"
                    to="/memberdashboard"
                    className='memberlist'
                  >
                    <i className="fas fa-tachometer-alt menu-icon"></i>
                    <span>Home</span>
                  </Link>
                </li>
                <li className={` ${active == '2' ? "active" : ""
                  }`}>
                  <Link
                    id="hs-bp"
                    to="/availablesessions"
                    className='memberlist'
                  >
                    <i className="fas fa-calendar-alt menu-icon"></i>
                    <span>Classes & Events</span>
                  </Link>
                </li>
                <li className={` ${active == '3' ? "active" : ""
                  }`}>
                  <Link
                    id="hs-bp"
                    to="/membershipplans"
                    className='memberlist'

                  >
                    <i className="fas fa-id-card menu-icon"></i>
                    <span>Plans & Renewals</span>
                  </Link>
                </li>
              </ul>
              <ul className="sidebar-menu gym-bar-block">
                <label className='sidebar-title'>Account</label>
                <li className={` ${active == '4' ? "active" : ""
                  }`}>
                  <Link
                    id="hs-bp"
                    to="/membertransaction"
                    className='memberlist'
                  >
                    <i className="fas fa-receipt menu-icon"></i>
                    <span>Transactions</span>
                  </Link>
                </li>
                <li className={` ${active == '5' ? "active" : ""
                  }`}>
                  <Link
                    id="hs-bp"
                    to="/memberprofile"
                    className='memberlist'

                  >
                    <i className="fas fa-user menu-icon"></i>
                    <span>Profile</span>
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <ul className="sidebar-menu gym-bar-block">
                <label className='sidebar-title'>Others</label>
                <li
                  className={` ${active === "10" ? "active" : ""
                    }`} onClick={handleLogoutClick}>
                  <Link
                    id="settings"
                    className='memberlist'
                  >
                    <i className="fas fa-sign-out-alt menu-icon"></i>
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <DropdownStyles />
      </div>

    </>
  );
};

export default Sidebar;